import { Config } from './config-schema'
import config from './config.json';

export const environment: Config = config